import { render, staticRenderFns } from "./PropertyClientAddBothDialog.vue?vue&type=template&id=cb22ecac"
import script from "./PropertyClientAddBothDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyClientAddBothDialog.vue?vue&type=script&lang=ts"
import style0 from "./PropertyClientAddBothDialog.vue?vue&type=style&index=0&id=cb22ecac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports